/**
 * See: https://nextjs.org/docs/app/api-reference/file-conventions/instrumentation-client
 */
import { config as appInsightsConfig } from '@/analytics/config';
import { loadAppInsights } from '@/analytics/loader';
import * as analytics from '@/analytics';

// Under e2e tests send analytics immediately
if (navigator.webdriver) appInsightsConfig.maxBatchInterval = 1;

loadAppInsights(appInsightsConfig);
analytics.initAppInsights();

// Don't use onRouterTransitionStart, because it does not provide page title.
